<template>
  <div>
    <h1>
      GEN
    </h1>
  </div>
</template>

<script>
export default {
name: "gen"
}
</script>

<style scoped>

</style>
